import Vue from "vue";

import {
    CollapseItem,
    Collapse,
    Calendar,
    UploaderUploader,
    RadioGroup,
    Radio,
    Picker,
    DropdownMenu,
    DropdownItem,
    Cell,
    CellGroup,
    Field,
    Button,
    List,
    PullRefresh,
    Area,
    Popup,
    Switch,
    Lazyload,
    Rate,
    ImagePreview,
    DatetimePicker,
    Uploader,
    Dialog,
    Toast,
    Image,
    overlay,
    Checkbox,
    CheckboxGroup,
    NavBar,
    Pagination,
    Search,
    Swipe,
    SwipeItem,
    IndexBar,
    IndexAnchor
} from "vant";
import "vant/lib/index.css";

Vue.use(IndexAnchor);
Vue.use(IndexBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Search);
Vue.use(Pagination);
Vue.use(NavBar);
Vue.use(Calendar);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(overlay);
Vue.use(Image);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(DatetimePicker);
Vue.use(ImagePreview);
Vue.use(Rate);
Vue.use(Lazyload);
Vue.use(Switch);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Button);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Picker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Uploader);

Vue.prototype.$Toast = Toast
Toast.setDefaultOptions({ duration: 1500 });
Vue.prototype.$Dialog = Dialog
Dialog.setDefaultOptions({ closeOnPopstate: true })